export class BespokeLetterModel {
  decisionId = 1;
  explanation = "";
  infoDetails = "";
  cancelOptionAnswer = "n";
  pinNumberAnswer = "n";
  encloseRefundAnswer = "n";
  tptAnswer = "n";
  tptWebPortalAnswer = "n";
}
